import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import FormChooseServiceV2 from '@/components/common/forms/form-choose-service-v2/FormChooseService-v2';
import ChooseService from '@/components/common/forms/form-choose-service-v3/ChooseService';
import FormChooseServiceV3 from '@/components/common/forms/form-choose-service-v3/FormChooseServiceV3';
import FormChooseService from '@/components/common/forms/form-choose-service/FormChooseService';
import NoData from '@/components/common/no-data/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import useGetOrganizationServices from '@/hooks/queries/services/useGetOrganizationServices';
import useGetOrgCategoriesWIthServices from '@/hooks/queries/services/useGetOrgCategoriesWithServices';
import type { TOrganizationFAQ } from '@/services/api/organization-api';
import { VEPCodes } from '@/utils/utils';
import type React from 'react';

const ChooseServiceStep: React.FC<{ organization: TOrganizationFAQ }> = ({
  organization
}) => {
  const featureFlags = process.env.NEXT_PUBLIC_FEATURE_FLAG
    ? JSON.parse(process.env.NEXT_PUBLIC_FEATURE_FLAG)
    : {};

  // get services
  const {
    isError,
    isPending,
    data: services
  } = useGetOrganizationServices(organization.id);

  const categoriesWithServices = useGetOrgCategoriesWIthServices(
    organization.id
  );

  if (isPending || categoriesWithServices.isPending) {
    return (
      <>
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
      </>
    );
  }
  if (!services?.length || !categoriesWithServices.data?.length)
    return <NoData />;

  if (isError || categoriesWithServices.isError) {
    return <ErrorMessage />;
  }

  if (featureFlags.serviceList === 'v2') {
    //TODO: borrar en caso de usar v3
    return (
      <FormChooseServiceV2
        services={services.filter((service) => !service.isExtension)}
        organization={organization}
      />
    );
  }

  if (featureFlags.serviceList === 'v3') {
    return (
      <>
        {VEPCodes.includes(organization.code) ? (
          <ChooseService services={categoriesWithServices.data} />
        ) : (
          <FormChooseServiceV3
            services={categoriesWithServices.data}
            organization={organization}
          />
        )}
      </>
    );
  }

  return (
    <FormChooseService
      services={services.filter((service) => !service.isExtension)}
      organization={organization}
    />
  );
};

export default ChooseServiceStep;
